import { useLocation, useNavigate } from 'react-router-dom';

import { useView } from '@/hooks';
import { SessionType } from '@/types';
import { Tab, Tabs } from '@/ui';

import type { FC, SyntheticEvent } from 'react';

const SessionsTabs: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isCoach, isOverview } = useView();
  const value = location.pathname.includes('past')
    ? SessionType.Past
    : SessionType.Upcoming;

  const onChange = (_: SyntheticEvent, next: number) => {
    const path = next === SessionType.Upcoming ? 'upcoming' : 'past';
    navigate(
      isOverview
        ? `../sessions/${path}`
        : `${isCoach ? '/coach' : '/m'}/sessions/${path}`,
    );
  };

  return (
    <Tabs aria-label="Session history" value={value} onChange={onChange}>
      <Tab label="Upcoming" />
      <Tab label="Past" />
    </Tabs>
  );
};

export default SessionsTabs;
